import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import { FormInput } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import { dirname } from 'path'
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Button, Segment } from 'semantic-ui-react'
import PropertiesList from './PropertiesList'

const mapStateToProps = (state, ownProps) => {
  const { propertiesLoading } = state.properties
  return { propertiesLoading }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      push,
    },
    dispatch
  )

class PropertiesBrowser extends React.Component {
  render() {
    const dark = config.theme.dark
    const { propertiesLoading, push } = this.props //redux
    const {
      location: { pathname },
      match: {
        params: { property_id },
      },
    } = this.props //router

    return (
      <div
        className={classNames([
          'PropertiesBrowser',
          'ui',
          'form',
          dark && 'inverted',
        ])}>
        <ComponentHeader
          title={I18n.t('admin.property_editor.properties.title')}
          customActions={[
            <Field
              component={FormInput}
              icon="search"
              name="filterText"
              placeholder={I18n.t('global.filter')}
            />,
            <Button
              primary
              icon="plus"
              onClick={(event) => {
                event.preventDefault()
                let basePath = pathname
                if (property_id) basePath = dirname(basePath)
                if (basePath.slice(-1) !== '/') basePath = basePath + '/'
                push(basePath + '+')
              }}
            />,
          ]}
        />

        <Segment
          attached
          loading={propertiesLoading}
          className={classNames([
            'payload',
            'scroll',
            dark && 'inverted',
            propertiesLoading && 'spaced',
          ])}>
          <PropertiesList />
        </Segment>
      </div>
    )
  }
}

PropertiesBrowser = connect(mapStateToProps, mapDispatchToProps)(
  PropertiesBrowser
)
PropertiesBrowser = reduxForm({ form: 'properties' })(PropertiesBrowser)
export default withRouter(PropertiesBrowser)



// WEBPACK FOOTER //
// ./src/components/admin/Properties/PropertiesBrowser.jsx